import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  Button,
  Row,
  Col,
  Divider,
  Form,
  Popover,
  Radio,
  InputNumber
} from 'antd'
import {
  loadIsMainLoading,
  loadIsDiscountRowVisible,
  loadIsPromoCodePopoverVisible,
  loadIsTaxPopoverVisible,
  loadIsPromotionPopoverVisible,
  loadIsDiscountPopoverVisible,
  loadIsPaymentPopoverVisible,
  loadBasicIsPercent,
  loadFormDiscPer,
  loadFormDiscCurr
} from '../../appRedux/actions/MainSale'
import { SellOrderJsonBuilder } from '../../appRedux/actions/SellOrderMethods'
import {
  closingNumPad,
  customParse,
  fetchCurrentSalesOrder,
  formatDigits,
  getDecryptID,
  loadActionLogs,
  loadNumPadType,
  loadNumRelateData,
  loadShowNumPadForDiscount
} from '../../appRedux/actions'
import { SALE_ACTION_LOG } from '../../constants/StoreSetting'
import NumPad from './NumPad'
import { NumPadTypes } from '../../constants/MobAppConstants'

const Discount = props => {
  const { discountPerm } = props
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const getIsDiscountRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsDiscountRowVisible
  )
  const getIsDiscountPopoverVisible = useSelector(
    ({ MainSale }) => MainSale.getIsDiscountPopoverVisible
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getDiscountPriceTotal = useSelector(
    ({ MainSale }) => MainSale.getDiscountPriceTotal
  )
  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const showNumPadForDiscount = useSelector(({ Sell }) => Sell.showNumPadForDiscount)

  const [getIsBasic, setIsBasic] = useState(true)
  // const [getBasicDisCardBtn, setBasicDisCardBtn] = useState("Percent");
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getSelectedReg, setSelectedReg] = React.useState('')
  const [formCalVal, setFormCalVal] = React.useState(0)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getReduxSelectedStoreOutlets.id && getReduxSelectedOutletReg.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        setSelectedReg(getReduxSelectedOutletReg.id)
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        let selectedLocalReg = localStorage.getItem('selectedReg')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          let selOutlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
          setSelectedOutlet(selOutlet)
        }
        if (selectedLocalReg) {
          selectedLocalReg = JSON.parse(selectedLocalReg)
          let selReg = getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : selectedLocalReg.id
          setSelectedReg(selReg)
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  const disocuntOptions = [
    { label: '%', value: 'Percent' },
    {
      label:
        getCurrData.currencyCode != null
          ? getCurrData.currencyCode
          : getCurrData.currencyName != null
          ? getCurrData.currencyName
          : getCurrData.currencySymbol,
      value: 'Currency'
    }
  ]
  const discountTitle = (
    <p className='custom-font-size-weight dk-pt3 dk-mgb-10'>
      <IntlMessages id='sell.sell.adddiscount' />
    </p>
  )

  function clickForNumPad (type, data) {
    // NOTE: 5 type for amount to pay
    dispatch(loadShowNumPadForDiscount(true))
    dispatch(loadNumPadType(type))
    dispatch(loadNumRelateData(data))
  }

  const discountContent = discountPerm ? (
    <div className='dk-mgt-3'>
      <Row>
        <Col md={12} xs={12} className='custom-pd-right0'>
          <Radio.Group
            options={disocuntOptions}
            onChange={radBtnBasic}
            optionType='button'
            size='middle'
            value={getBasicIsPercent ? 'Percent' : 'Currency'}
            disabled={getDiscountPriceTotal && getDiscountPriceTotal > 0}
          />
        </Col>

        <Col md={12} xs={12} className='custom-pd-left0'>
          <Form
            name='SellForm'
            form={form}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            scrollToFirstError
            initialValues={{
              disPercent: '0.0'
            }}
          >
            {getBasicIsPercent ? (
              <>
                <div
                  onClick={() =>
                    clickForNumPad(NumPadTypes.WHOLE_DISCOUNT, {
                      data: formDiscPer,
                      type: 'percent'
                    })
                  }
                  style={{ marginTop: 5, marginLeft: 5, cursor: 'pointer' }}
                >{`${
                  formCalVal ? formCalVal : formDiscPer ? formDiscPer : '0.00'
                } %`}</div>
                {/* <Form.Item
                  className='ant-form-custom-alignment custom-mg-bt-0'
                  name='disPercent'
                  rules={[
                    {
                      required: getIsBasic && getBasicIsPercent ? true : false,
                      message: (
                        <IntlMessages id='products.promoadd.disperalert' />
                      )
                    }
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={100}
                    step={0.1}
                    formatter={value => `${value}%`}
                    parser={value => value.replace('%', '')}
                    size='middle'
                    style={{ width: '100%' }}
                    value={formDiscPer}
                    // onChange={(e) => changeDiscPer(e)}
                  />
                </Form.Item> */}
              </>
            ) : (
              <>
                <div
                  onClick={() =>
                    clickForNumPad(NumPadTypes.WHOLE_DISCOUNT, {
                      data: formDiscCurr,
                      type: 'currency'
                    })
                  }
                  style={{ marginTop: 5, marginLeft: 5, cursor: 'pointer' }}
                >{`${
                  formCalVal ? formCalVal : formDiscCurr ? formDiscCurr : '0.00'
                } ${
                  getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol
                }`}</div>
                {/* <Form.Item
                  className='ant-form-custom-alignment custom-mg-bt-0'
                  name='disCurrency'
                  rules={[
                    {
                      required: getIsBasic && !getBasicIsPercent ? true : false,
                      message: (
                        <IntlMessages id='products.promoadd.discurralert' />
                      )
                    }
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={
                      getCurrentSalesOrderData &&
                      getCurrentSalesOrderData.TotalPrice
                        ? getCurrentSalesOrderData.TotalPrice
                        : 10000
                    }
                    step={0.5}
                    // formatter={(value) =>
                    //   `${value}${getCurrData.currencyCode != null
                    //     ? getCurrData.currencyCode
                    //     : getCurrData.currencyName != null
                    //       ? getCurrData.currencyName
                    //       : getCurrData.currencySymbol
                    //   }`
                    // }
                    // parser={(value) =>
                    //   value.replace(
                    //     `${getCurrData.currencyCode != null
                    //       ? getCurrData.currencyCode
                    //       : getCurrData.currencyName != null
                    //         ? getCurrData.currencyName
                    //         : getCurrData.currencySymbol
                    //     }.`,
                    //     ""
                    //   )
                    // }
                    size='middle'
                    style={{ width: '100%' }}
                    value={formDiscCurr}
                    // onChange={e => changeDiscCurr(e)}
                  />
                </Form.Item> */}
              </>
            )}
          </Form>
        </Col>
      </Row>
      <div className='dk-text--sub dk-text--secondary dk-mt3 dk-mb3'>
        <IntlMessages id='sell.sell.thisdiscountwill' />
      </div>
      <div className='dk-flex dk-discount-popover-footer dk-pt3 dk-pb3'>
        <Button
          className='dk-btn-cancel'
          type='primary'
          onClick={() => {
            setFormCalVal(0)
            closingNumPad(dispatch)
            handleDiscountVisibleChange(false)
          }}
        >
          <IntlMessages id='products.suppliers.cancel' />
        </Button>
        <Button
          onClick={() => {
            let type = getBasicIsPercent ? 'percent' : 'cash'
            let key = getBasicIsPercent ? 'disPercent' : 'disCurrency'
            let input = formCalVal // getBasicIsPercent ? formDiscPer : formDiscCurr // form.getFieldValue(key)
            addDiscCurr(input, type)
          }}
          className='dk-btn-add  dk-mgr-19'
          type='primary'
          disabled={
            getIsRefundSale ||
            getDecryptID(getCurrentSalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
            getDecryptID(getCurrentSalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('On Account'))
          }
        >
          <IntlMessages id='sell.sell.add' />
        </Button>
      </div>
    </div>
  ) : (
    <div className='dk-mgt-3'>
      <Row style={{ padding: '18px' }} justify='center'>
        <Col>
          <h3>
            <IntlMessages id='discount.permission' />
          </h3>
        </Col>
      </Row>
      <div className='dk-flex dk-discount-popover-footer dk-pt3 dk-pb3'>
        <Button
          className='custom-btn-cancel-sell mr-3'
          type='primary'
          onClick={() => {
            handleDiscountVisibleChange(false)
          }}
        >
          <IntlMessages id='products.suppliers.cancel' />
        </Button>
      </div>
    </div>
  )

  // function changeDiscPer(e) {
  //   dispatch(loadFormDiscPer(e));
  // }

  function addDiscCurr (e, type) {
    let forPercent = 0
    let forCash = 0
    if (type == 'cash') {
      forCash = e
      dispatch(loadFormDiscCurr(e))
      dispatch(loadFormDiscPer(0))
    } else if (type == 'percent') {
      forPercent = e
      dispatch(loadFormDiscPer(e))
      dispatch(loadFormDiscCurr(0))
    }
    SellOrderJsonBuilder(
      getReduxSaleProductJsonData,
      getSelectedOutlet,
      getSelectedReg,
      getBasicIsPercent,
      getCustomerSearchData,
      getIsRefundSale,
      getDefaultDecimalPlaces,
      getCurrentSalesOrderData,
      getCurrentSalesOrderStatusID,
      forCash,
      forPercent,
      formSellNote,
      getRefundKeys,
      getSalePayments,
      dispatch,
      false,
      getIsTaxExclusive,
      false,
      getSavings,
      sellSelAttributes
    )
    handleDiscountVisibleChange(false)
    setActionLog(e, SALE_ACTION_LOG.SaleDiscount, type)
    setFormCalVal(0)
    closingNumPad(dispatch)
  }

  function setActionLog (value, identify, type) {
    const comment = `The sale whole discount is ${
      type == 'cash' ? 'in amount' : 'in percentage'
    } with the value of ${value}${
      type == 'percent' ? '%' : '(total reduced amount)'
    }. Created by ${
      getReduxStoreInfo && getReduxStoreInfo.userName
        ? getReduxStoreInfo.userName
        : 'XXX'
    } with userID of ${
      getReduxStoreInfo && getReduxStoreInfo.userID
        ? getDecryptID(getReduxStoreInfo.userID)
        : ''
    }`
    const body = {
      ActionBy:
        getReduxStoreInfo && getReduxStoreInfo.userID
          ? getReduxStoreInfo.userID
          : '',
      Comment: comment,
      FromValue: 0,
      ToValue: value,
      SaleActionLogTypeId: `${identify}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
      key: ''
    }
    const data = sellActionLog && sellActionLog.length > 0 ? sellActionLog : []
    dispatch(loadActionLogs(data.concat(body)))
  }

  const onFinish = values => {
    // setIsMainLoading(true);
    dispatch(loadIsMainLoading(true))
  }

  function radBtnBasic (evt) {
    // setBasicDisCardBtn(evt.target.value);
    if (evt.target.value === 'Percent') {
      dispatch(loadBasicIsPercent(true))
    } else if (evt.target.value === 'Currency') {
      dispatch(loadBasicIsPercent(false))
    }
  }

  const onFinishFailed = errorInfo => {}

  const handleDiscountVisibleChange = isPopOverVisible => {
    dispatch(loadIsDiscountPopoverVisible(isPopOverVisible))
    dispatch(loadIsPromotionPopoverVisible(false))
    dispatch(loadIsTaxPopoverVisible(false))
    dispatch(loadIsPromoCodePopoverVisible(false))
    dispatch(loadIsPaymentPopoverVisible(false))
  }

  function removeSaleDiscount (wholeRem) {
    const actionLog =
      sellActionLog && sellActionLog.length > 0
        ? sellActionLog.filter(
            a =>
              getDecryptID(a.SaleActionLogTypeId) !=
              SALE_ACTION_LOG.SaleDiscount
          )
        : sellActionLog
    dispatch(loadActionLogs(actionLog && actionLog.length > 0 ? actionLog : []))
    dispatch(loadFormDiscPer(0))
    dispatch(loadFormDiscCurr(0))
    SellOrderJsonBuilder(
      getReduxSaleProductJsonData,
      getSelectedOutlet,
      getSelectedReg,
      getBasicIsPercent,
      getCustomerSearchData,
      getIsRefundSale,
      getDefaultDecimalPlaces,
      getCurrentSalesOrderData,
      getCurrentSalesOrderStatusID,
      0,
      0,
      formSellNote,
      getRefundKeys,
      getSalePayments,
      dispatch,
      wholeRem,
      getIsTaxExclusive,
      false,
      getSavings,
      sellSelAttributes
    )
    dispatch(loadIsDiscountRowVisible(false))
  }

  return (
    getIsDiscountRowVisible && (
      <>
        {showNumPadForDiscount && <NumPad setFormCalVal={setFormCalVal} from='discount' />}
        <Row className='sale-list-footer-item-1 cart-sl'>
          <Col md={9} xs={9} sm={9} lg={9}>
            <div className='aParent'>
              <div>
                <Popover
                  placement='left'
                  title={
                    getIsSalePaymentProcessStart ? (
                      <p style={{ color: '#ec3232' }}>
                        Discount can't be applied, Payment has started
                      </p>
                    ) : (
                      discountTitle
                    )
                  }
                  content={
                    getIsSalePaymentProcessStart ? (
                      <>
                        {/* <Row>
                          <Col>
                            <p style={{ color: '#ec3232' }}>
                              Payment has been started, more discount can't be
                              applied
                            </p>
                          </Col>
                        </Row> */}
                        <Row justify='end' style={{ marginRight: 1 }}>
                          <Col>
                            <Button
                              type='primary'
                              onClick={() => handleDiscountVisibleChange(false)}
                            >
                              OK
                            </Button>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      discountContent
                    )
                  }
                  trigger='click'
                  defaultVisible={true}
                  visible={getIsDiscountPopoverVisible && !showNumPadForDiscount}
                  overlayClassName='customer-sell-popover'
                  style={{ top: `${275 * getReduxSaleProductJsonData}px` }}
                >
                  <p
                    className='custom-font-size-weight dk-link'
                    onClick={() => {
                      if (!getIsRefundSale) {
                        handleDiscountVisibleChange(true)
                      }
                    }}
                  >
                    <IntlMessages id='sell.sell.discount1' />
                  </p>
                </Popover>
              </div>
              <div>
                {getBasicIsPercent && formDiscPer > 0 && (
                  <span style={{ fontSize: 'large', marginLeft: 8 }}>
                    {`${formDiscPer}%`}
                  </span>
                )}
              </div>
            </div>
          </Col>

          <Col md={12} xs={10} sm={11} lg={12}>
            <p className='custom-font-size-weight custom-font-color-black text-rite dk-mt-24'>
              {getDiscountPriceTotal ? (
                <>
                  {`${getCurrData.currencyCode} ${
                    getIsRefundSale ? '' : '-'
                  }${formatDigits(
                    getDiscountPriceTotal,
                    getDefaultDecimalPlaces
                  )}`}
                </>
              ) : (
                <>{`${getCurrData.currencyCode} 0.00`}</>
              )}
            </p>
          </Col>

          <Col
            md={3}
            xs={5}
            sm={4}
            lg={3}
            className='custom-col-text-center text-rite del-btn-div'
          >
            {!getIsRefundSale &&
              getDecryptID(getCurrentSalesOrderStatusID) !=
                getDecryptID(fetchCurrentSalesOrder('LayBy')) &&
              getDecryptID(getCurrentSalesOrderStatusID) !=
                getDecryptID(fetchCurrentSalesOrder('On Account')) && (
                <span>
                  <a
                    onClick={() => {
                      removeSaleDiscount(
                        customParse(
                          getDiscountPriceTotal ? getDiscountPriceTotal : 0
                        )
                      )
                    }}
                    className='trash-icon-btn'
                  >
                    <i className='icon icon-trash' />
                  </a>
                </span>
              )}
          </Col>
        </Row>

        <Divider />
      </>
    )
  )
}

export default Discount
